/**
 * Quantity Selector Component
 * Handles both traditional +/- buttons and 3-button quantity selectors
 * Uses conditional logic to prevent conflicts
 */
document.addEventListener('DOMContentLoaded', function() {
  const quantityInput = document.querySelector('[data-quantity-input]');
  
  // Exit if no quantity input exists
  if (!quantityInput) {
    console.warn('Quantity input not found');
    return;
  }
  
  // CHECK WHICH SELECTOR TYPE IS PRESENT
  const traditionalElements = {
    decrease: document.querySelector('[data-quantity-decrease]'),
    increase: document.querySelector('[data-quantity-increase]')
  };
  
  const buttonElements = document.querySelectorAll('[data-quantity-option]');
  
  const hasTraditionalSelector = traditionalElements.decrease && traditionalElements.increase;
  const hasButtonSelector = buttonElements.length > 0;
  
  console.log('Selector detection:', { hasTraditionalSelector, hasButtonSelector });
  
  // INITIALIZE ONLY THE APPROPRIATE SELECTOR
  if (hasTraditionalSelector && !hasButtonSelector) {
    console.log('Initializing traditional +/- selector');
    initializeTraditionalSelector();
  } else if (hasButtonSelector) {
    console.log('Initializing button selector');
    initializeButtonSelector();
  } else if (hasTraditionalSelector && hasButtonSelector) {
    console.warn('Both selectors found - prioritizing button selector');
    initializeButtonSelector();
  } else {
    console.warn('No quantity selector elements found');
  }
  
  /**
   * Initialize Traditional +/- Selector
   */
  function initializeTraditionalSelector() {
    const decreaseBtn = traditionalElements.decrease;
    const increaseBtn = traditionalElements.increase;
    
    // Anti-recursion flag
    let isUpdating = false;
    
    /**
     * Update quantity value and button states
     */
    function updateQuantity(newValue) {
      if (isUpdating) return;
      isUpdating = true;
      
      const min = parseInt(quantityInput.getAttribute('min')) || 1;
      const max = parseInt(quantityInput.getAttribute('max')) || 10;
      
      // Ensure value is within bounds
      newValue = Math.max(min, Math.min(max, newValue));
      
      // Update input value
      quantityInput.value = newValue;
      
      // Update button states
      decreaseBtn.disabled = newValue <= min;
      increaseBtn.disabled = newValue >= max;
      
      // Add visual feedback for disabled buttons
      if (newValue <= min) {
        decreaseBtn.classList.add('opacity-50', 'cursor-not-allowed');
      } else {
        decreaseBtn.classList.remove('opacity-50', 'cursor-not-allowed');
      }
      
      if (newValue >= max) {
        increaseBtn.classList.add('opacity-50', 'cursor-not-allowed');
      } else {
        increaseBtn.classList.remove('opacity-50', 'cursor-not-allowed');
      }
      
      // Trigger change event for cart functionality
      setTimeout(() => {
        const changeEvent = new Event('change', { bubbles: true });
        quantityInput.dispatchEvent(changeEvent);
        isUpdating = false;
      }, 0);
      
      console.log('Traditional selector - Quantity updated to:', newValue);
    }
    
    /**
     * Handle decrease button click
     */
    function handleDecrease(e) {
      e.preventDefault();
      if (decreaseBtn.disabled) return;
      
      const currentValue = parseInt(quantityInput.value) || 1;
      updateQuantity(currentValue - 1);
      
      // Add click feedback
      decreaseBtn.style.transform = 'scale(0.95)';
      setTimeout(() => {
        decreaseBtn.style.transform = 'scale(1)';
      }, 100);
    }
    
    /**
     * Handle increase button click
     */
    function handleIncrease(e) {
      e.preventDefault();
      if (increaseBtn.disabled) return;
      
      const currentValue = parseInt(quantityInput.value) || 1;
      updateQuantity(currentValue + 1);
      
      // Add click feedback
      increaseBtn.style.transform = 'scale(0.95)';
      setTimeout(() => {
        increaseBtn.style.transform = 'scale(1)';
      }, 100);
    }
    
    /**
     * Handle direct input changes
     */
    function handleInputChange() {
      if (isUpdating) return;
      
      let newValue = parseInt(quantityInput.value);
      
      if (isNaN(newValue) || newValue < 1) {
        newValue = 1;
      }
      
      updateQuantity(newValue);
    }
    
    /**
     * Handle keyboard navigation
     */
    function handleKeyDown(event) {
      const currentValue = parseInt(quantityInput.value) || 1;
      
      switch(event.key) {
        case 'ArrowUp':
          event.preventDefault();
          handleIncrease(event);
          break;
        case 'ArrowDown':
          event.preventDefault();
          handleDecrease(event);
          break;
        case 'Home':
          event.preventDefault();
          updateQuantity(parseInt(quantityInput.getAttribute('min')) || 1);
          break;
        case 'End':
          event.preventDefault();
          updateQuantity(parseInt(quantityInput.getAttribute('max')) || 10);
          break;
      }
    }
    
    // Event listeners for traditional selector
    decreaseBtn.addEventListener('click', handleDecrease);
    increaseBtn.addEventListener('click', handleIncrease);
    quantityInput.addEventListener('input', handleInputChange);
    quantityInput.addEventListener('keydown', handleKeyDown);
    
    // Handle focus/blur for better UX
    quantityInput.addEventListener('focus', function() {
      this.select();
    });
    
    quantityInput.addEventListener('blur', function() {
      handleInputChange();
    });
    
    // Initialize button states
    const initialValue = parseInt(quantityInput.value) || 1;
    updateQuantity(initialValue);
    
    // Add smooth transitions
    addTraditionalStyles();
  }
  
  /**
   * Initialize Button Selector (3-button style)
   */
  function initializeButtonSelector() {
    const quantityOptions = buttonElements;
    
    // Anti-recursion flag
    let isUpdating = false;
    
    quantityOptions.forEach(button => {
      // Initialize state
      let isActive = button.getAttribute('data-quantity-value') === '1';
      button.isActive = isActive;
      
      // Click handler
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (isUpdating) return;
        isUpdating = true;
        
        const selectedQuantity = this.getAttribute('data-quantity-value');
        
        // Update the input value
        quantityInput.value = selectedQuantity;
        
        // Update active states
        quantityOptions.forEach(btn => {
          btn.isActive = false;
          btn.style.border = '1px solid #ccc';
        });
        
        // Set this button as active
        this.isActive = true;
        this.style.border = '2px solid #333';
        
        // Trigger change event with delay to prevent recursion
        setTimeout(() => {
          const changeEvent = new Event('change', { bubbles: true });
          quantityInput.dispatchEvent(changeEvent);
          isUpdating = false;
        }, 0);
        
        console.log('Button selector - Quantity updated to:', selectedQuantity);
      });
      
      // Hover effects
      button.addEventListener('mouseenter', function() {
        if (!this.isActive) {
          this.style.border = '2px solid #333';
        }
      });
      
      button.addEventListener('mouseleave', function() {
        if (!this.isActive) {
          this.style.border = '1px solid #ccc';
        }
      });
    });
    
    // Initialize styles
    const firstButton = document.querySelector('[data-quantity-value="1"]');
    if (firstButton) {
      firstButton.style.border = '2px solid #333';
      firstButton.isActive = true;
    }
    
    quantityOptions.forEach(btn => {
      if (btn.getAttribute('data-quantity-value') !== '1') {
        btn.style.border = '1px solid #ccc';
        btn.isActive = false;
      }
    });
  }
  
  /**
   * Add styles for traditional selector
   */
  function addTraditionalStyles() {
    if (document.querySelector('#quantity-selector-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'quantity-selector-styles';
    style.textContent = `
      [data-quantity-decrease],
      [data-quantity-increase] {
        transition: transform 0.1s ease, background-color 0.2s ease, opacity 0.2s ease;
      }
      
      [data-quantity-input] {
        transition: border-color 0.2s ease;
      }
      
      [data-quantity-input]:focus {
        border-color: #000;
        box-shadow: 0 0 0 1px #000;
      }
    `;
    document.head.appendChild(style);
  }
  
  console.log('Quantity selector initialization complete');
});